export default __webpack_public_path__ + "static/media/travel-site-icon.552ed146.jpg";